module.exports = require("webpack/lib/MultiEntryPlugin");


//////////////////
// WEBPACK FOOTER
// external "webpack/lib/MultiEntryPlugin"
// module id = 81
// module chunks = 0